import { payStatusFilter } from '../../utils/textFilter';

export const buildAllPaymentRequest = ({ page, searchType, searchWord, param = {} }) => ({
    page,
    size: 10,
    searchType,
    searchWord,
    ...param,
});

export const getAllPaymentList = (response) => response?.data?.data || [];

export const getAllPaymentCount = (response) => {
    const count = Number(response?.data?.all_cnt);
    return Number.isFinite(count) && count >= 0 ? count : 0;
};

export const getPaymentDetail = (response) => {
    const detail = response?.data?.data?.[0];
    return detail && typeof detail === 'object' ? { ...detail } : null;
};

export const getPaymentStatusText = (row = {}) => {
    const contents = Number(row.pay_contents ?? row.contents);
    const type = Number(row.pay_type_number ?? row.pay_type);
    const status = Number(row.pay_status_number ?? row.pay_status);
    if (contents === 6 && type === 5 && status === 1) return '현장결제';
    if (typeof row.pay_status === 'string' && !Number.isFinite(Number(row.pay_status))) return row.pay_status;
    return payStatusFilter(status);
};
